import {game} from './game'

const production = process.env.NODE_ENV === 'production'

export const initialize = {
  init: function() {
    game.scale.scaleMode = Phaser.ScaleManager.SHOW_ALL

    game.scale.pageAlignHorizontally = true
    game.scale.pageAlignVertically = true

    game.physics.startSystem(Phaser.Physics.ARCADE)
  },
  preload: () => {
    let path = ''
    if (production) {
      path = '/king-rail'
    }
    game.load.image('sky', `${path}/assets/sky.png`)
    game.load.image('ground', `${path}/assets/grass.gif`)
    game.load.image('heart', `${path}/assets/heart.gif`)
    game.load.image('player', `${path}/assets/king32.png`, 32, 48)
    game.load.image('sword', `${path}/assets/sword.png`, 32, 48)
  },
  create: () => {
    game.stage.backgroundColor = 'red'
    game.state.start('play')
  },
  update: () => {},
}



/** WEBPACK FOOTER **
 ** ./src/initialize.js
 **/